import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import { focusStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

const _buttonLineHeight = TYPOGRAPHY.lineHeight.small;

const _sectionHeaderButtonBaseStyles = () => {
    return css`
        padding: 1em 1.4em;
        border: 0;
        font-size: ${TYPOGRAPHY.size.smaller};
        line-height: ${_buttonLineHeight};
        ${props =>
            breakpointValuesMediaQueries(
                props.theme,
                [{ values: [TYPOGRAPHY.size.smaller, null, TYPOGRAPHY.size.base], properties: ["font-size"] }],
                mediaOptions.min,
            )}
    `;
};

const _sectionHeaderButtonFocusStyles = () => {
    return css`
        ${focusStyles()}
        &:focus,
        &:focus-visible {
            ${focusStyles()}
            ${_sectionHeaderButtonBaseStyles()}
        }
    `;
};

export default {
    defaultProps: {},
    sectionDefaultProps: {
        headerProps: {
            css: css`
                button {
                    background-color: ${getColor("common.accent")};
                    ${_sectionHeaderButtonBaseStyles()}
                    ${_sectionHeaderButtonFocusStyles()}

                    &:hover {
                        text-decoration: underline;
                    }

                    &[aria-expanded="true"] {
                        background-color: ${getColor("common.border")};
                    }
                }

                ${/* sc-selector */ AccordionSectionPanel} + && {
                    margin-top: 4px;

                    button {
                        ${_sectionHeaderButtonBaseStyles()}
                        ${_sectionHeaderButtonFocusStyles()}
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                padding: 1em;
                border: 1px solid ${getColor("common.border")};
            `,
        },
        titleTypographyProps: {
            forwardAs: "span",
            weight: TYPOGRAPHY.weight.bold,
            color: null,
            size: "inherit",
            lineHeight: "inherit",
        },
        toggleIconProps: {
            color: null,
            css: css`
                height: ${_buttonLineHeight}em;
                width: ${_buttonLineHeight}em;
                position: relative;
                top: 0.05em;

                svg {
                    width: inherit;
                    height: inherit;
                    transform: scale(1.25);
                }
            `,
        },
    },
};
